import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'erasure-method',
    pluginName: 'ADMIN',
    entityName: 'ERASURE_METHOD',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch erasure methods action creators
export const fetchErasureMethodInit = () => {
    return crudActions.fetchInit();
};
export const fetchErasureMethodStart = () => {
    return crudActions.fetchStart();
};
export const fetchErasureMethodSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchErasureMethodFail = () => {
    return crudActions.fetchFail();
};
export const fetchErasureMethodCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchErasureMethodStart());
        try {
            let countRes = await rest.post("/erasure-method/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchErasureMethodSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchErasureMethodFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch securaze standards."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchErasureMethodFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch securaze standards."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchErasureMethod = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchErasureMethodStart());
        try {
            let listRes = await rest.post("/erasure-method/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchErasureMethodSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchErasureMethodFail());
            return []

        } catch (error) {
            dispatch(fetchErasureMethodFail());
            return []
        }
    }
}

// Load erasure method action creators
export const loadErasureMethodInit = () => {
    return crudActions.loadInit();
};
export const loadErasureMethodStart = () => {
    return crudActions.loadStart();
};
export const loadErasureMethodSuccess = loadedErasureMethod => {
    return crudActions.loadSuccess(loadedErasureMethod);
};
export const loadErasureMethodFail = error => {
    return crudActions.loadFail(error);
};
export const loadErasureMethod = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};

// Create erasure method action creators
export const createErasureMethodInit = () => {
    return crudActions.createInit();
};
export const createErasureMethodStart = () => {
    return crudActions.createStart();
};
export const createErasureMethodSuccess = createdErasureMethod => {
    return crudActions.createSuccess(createdErasureMethod);
};
export const createErasureMethodFail = error => {
    return crudActions.createFail(error);
};

export const createErasureMethod = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createErasureMethodStart());
        try {
            let res = await rest.post('/erasure-method/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created securaze standard.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createErasureMethodFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create securaze standard."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create securaze standard."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createErasureMethodFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Edit erasure method action creators
export const editErasureMethodInit = () => {
    return crudActions.editInit();
};
export const editErasureMethodStart = () => {
    return crudActions.editStart();
};
export const editErasureMethodSuccess = editedErasureMethod => {
    return crudActions.editSuccess(editedErasureMethod);
};
export const editErasureMethodFail = error => {
    return crudActions.editFail(error);
};

export const editErasureMethod = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editErasureMethodStart());
        try {
            let res = await rest.post('/erasure-method/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated securaze standard.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editErasureMethodFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit securaze standard."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit securaze standard."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editErasureMethodFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Bulk delete erasure methods action creators
export const bulkDeleteErasureMethodsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteErasureMethodsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteErasureMethodsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteErasureMethodsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteErasureMethods = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteErasureMethodsStart());
        try {
            let res = await rest.post('/erasure-method/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteErasureMethodsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted securaze standards.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteErasureMethodsFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete securaze standards."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete securaze standards."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteErasureMethodsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const listSupportedClientTypes = (data, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/supported-client-type/list', data, options);
            if (res.data && res.data.succeeded) {
                let supportedClientTypes = [];
                for (var supportedClientType of res.data.result.data) {
                    supportedClientTypes.push({ value: supportedClientType.SupportedClientTypeID, label: `${supportedClientType.Name}` });
                }
                return supportedClientTypes;
            } else {
                if (res && res.canceled) {
                    return [];
                }
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list supported client types."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
}
